import { DevicesAppWebComponent } from './component/DevicesAppWebComponent';
import { WEB_COMPONENT_DEVICES_APP } from '../../webcomponents.constants';

export { DevicesAppWebComponent };

window.customElements.define(WEB_COMPONENT_DEVICES_APP, DevicesAppWebComponent);
